import { render, staticRenderFns } from "./footbar.vue?vue&type=template&id=098f3853&scoped=true"
import script from "./footbar.vue?vue&type=script&lang=js"
export * from "./footbar.vue?vue&type=script&lang=js"
import style0 from "./footbar.vue?vue&type=style&index=0&id=098f3853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f3853",
  null
  
)

export default component.exports